import { v4 as uuidv4 } from "uuid";

const handleQuestionChange =
  (materials, setMaterials) => (material, changes) => {
    setMaterials((prevMaterials) => {
      const index = prevMaterials.findIndex(
        (m) => m.questionId === material.questionId
      );

      if (index === -1) return prevMaterials;

      const currentMaterial = prevMaterials[index];
      const hasChanges = Object.keys(changes).some(
        (key) => currentMaterial[key] !== changes[key]
      );

      if (!hasChanges) return prevMaterials;

      const newMaterials = [...prevMaterials];
      newMaterials[index] = {
        ...currentMaterial,
        ...changes,
      };

      return newMaterials;
    });
  };

const createNewMaterial = (type, additionalProps = {}) => ({
  type,
  size: "medium",
  alignment: "center",
  border: "shadow",
  ...additionalProps,
});

const createQuestionMaterial = (questionType) => {
  const baseMaterial = {
    type: "questions",
    questionType,
    score: 1,
    border: "shadow",
    tip: "",
    questionId: uuidv4(),
  };

  const questionTypeConfigs = {
    "Sentence Ordering": {
      sentences: [],
      correctAnswers: [],
    },
    "Fill in the Blanks": {
      question: "",
      correctAnswers: [],
    },
    "Spell the Word": {
      sentence: "",
    },
    Pairing: {
      question: "",
      leftItems: [],
      rightItems: [],
      pairs: [],
    },
    "The Guessinator": {
      question: "",
      gameWord: "",
      gameType: "The Guessinator",
    },
    Flashcards: {
      question: "",
      cards: [{ front: "", back: "" }],
    },
    "Open-Ended Text": {
      content: "",
      questionCategories: ["writing skills", "critical thinking"],
    },
    default: {
      question: "",
      options: ["", "", "", ""],
      correctAnswers: [],
    },
  };

  return {
    ...baseMaterial,
    ...(questionTypeConfigs[questionType] || questionTypeConfigs.default),
  };
};

export const isCountableQuestion = (material) => {
  if (!material.questionId) return false;

  // Games are not counted as questions
  if (
    material.questionType === "Flashcards" ||
    material.questionType === "The Guessinator" ||
    material.questionType === "Lucky Spin"
  ) {
    return false;
  }

  // Audio recorders with recordings or audio materials are not counted
  if (
    (material.type === "audio-recorder" && material.audioURL) ||
    material.type === "audio" ||
    material.type === "video" ||
    material.type === "image"
  ) {
    return false;
  }

  return true;
};

export { handleQuestionChange, createNewMaterial, createQuestionMaterial };
